import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import { ScrollListContainerBaseComponent } from './scroll-list-container-base.component';

@Component({
  selector: 'vi-ui-scroll-list',
  templateUrl: './scroll-list-container.component.html',
  styleUrls: ['./scroll-list-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollListContainerComponent<T> extends ScrollListContainerBaseComponent<T> {
  // VirtualScrollBaseComponent properties
  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;
  @Input() public items: T[];
  @Input() public isLoading: boolean;
  @Input() public hasMore?: boolean = true;
  @Input() public itemSize: number = 20;
  @Input() public isVirtualScrollActive: boolean = false;
  @Output() public loadMore: EventEmitter<void> = new EventEmitter<void>();

  // CDK Virtual Scroll properties
  @Input() public minBufferPx: number = this.itemSize * 10;
  @Input() public maxBufferPx: number = this.itemSize * 20;

  // Templates
  @ContentChild('itemTemplate') itemTemplate: TemplateRef<unknown>;
  @ContentChild('emptyListTemplate') emptyListTemplate: TemplateRef<unknown>;
  @ContentChild('loadingMoreTemplate') loadingMoreTemplate: TemplateRef<unknown>;
  @ContentChild('shimmerTemplate') shimmerTemplate: TemplateRef<unknown>;

  public get isInitialLoad(): boolean {
    return !this.items || this.items.length === 0;
  }

  public trackByFn(index: number): number {
    return index;
  }

  public onLoadMore(event): void {
    this.loadMore.emit(event);
  }
}
